/**
 * Patient document / clinical attachment upload allowlists.
 * Keep in sync with backend `patient/constant/patient-file-upload.ts`.
 */

export const PATIENT_UPLOAD_EXTENSIONS = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "bmp",
  "heic",
  "heif",
  "doc",
  "docx",
  "csv",
  "txt",
  "mp3",
  "mp4",
  "mov",
];

/** Documents + Authorization Documents (images + PDF + HEIC). */
export const PATIENT_DOC_UPLOAD_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif,image/jpeg,image/png,application/pdf";

export const PATIENT_DOC_UPLOAD_TYPES_LABEL = "PDF, JPG, PNG, HEIC";

/** Clinical form Upload Documents modal (broader set + iPhone HEIC). */
export const CLINICAL_ATTACHMENT_UPLOAD_ACCEPT = [
  ".pdf",
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".bmp",
  ".heic",
  ".heif",
  ".doc",
  ".docx",
  ".csv",
  ".txt",
  ".mp3",
  ".mp4",
  ".mov",
  "image/heic",
  "image/heif",
].join(",");

export const CLINICAL_ATTACHMENT_UPLOAD_TYPES_LABEL =
  "pdf, png, jpg, jpeg, gif, webp, bmp, heic, heif, doc, docx, csv, txt, mp3, mp4, mov";

export const PATIENT_UPLOAD_MAX_BYTES = 20 * 1024 * 1024;

export const PATIENT_UPLOAD_MAX_MB = 20;

export function formatPatientUploadMaxSize() {
  return `${PATIENT_UPLOAD_MAX_MB} MB`;
}

/**
 * @param {File} file
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validatePatientUploadFileClient(file) {
  if (!file?.name) {
    return { ok: false, message: "Please select a file" };
  }
  if (!isAllowedPatientUploadFile(file)) {
    return {
      ok: false,
      message: `Invalid file type. Allowed: ${PATIENT_DOC_UPLOAD_TYPES_LABEL}`,
    };
  }
  if (file.size > PATIENT_UPLOAD_MAX_BYTES) {
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    return {
      ok: false,
      message: `File is too large (${sizeMb} MB). Maximum size is ${formatPatientUploadMaxSize()}.`,
    };
  }
  return { ok: true };
}

export function getUploadExtension(fileName = "") {
  const parts = String(fileName).split(".");
  if (parts.length < 2) return "";
  return parts.pop()?.toLowerCase() ?? "";
}

export function isAllowedPatientUploadFile(file) {
  if (!file?.name) return false;
  const ext = getUploadExtension(file.name);
  return PATIENT_UPLOAD_EXTENSIONS.includes(ext);
}
